import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-chevron-left",
  templateUrl: "./med-icon-chevron-left.component.html",
})
export class MedIconChevronLeftComponent extends SvgMixinComponent {}
